import { BACKEND_URL } from "./editorConstants";

const parseResponse = async (res, mode = "json") => {
  const raw = await res.text();
  let parsed;

  try {
    parsed = raw ? JSON.parse(raw) : null;
  } catch {
    parsed = raw;
  }

  if (!res.ok) {
    const detail =
      (parsed && typeof parsed === "object" && parsed.detail) ||
      (typeof parsed === "string" && parsed) ||
      `Request failed with status ${res.status}`;
    throw new Error(detail);
  }

  if (mode === "text") {
    return typeof parsed === "string" ? parsed : raw;
  }

  return parsed;
};

export const getExperimentState = async (experimentId) => {
  const res = await fetch(
    `${BACKEND_URL}/api/editor/experiment-state?experiment_id=${experimentId}`
  );
  return parseResponse(res);
};

export const getPageHtml = async (pageUrl) => {
  const res = await fetch(
    `${BACKEND_URL}/api/editor/page?url=${encodeURIComponent(pageUrl)}`
  );
  return parseResponse(res, "text");
};

export const saveJson = async (experimentId, changes) => {
  const res = await fetch(`${BACKEND_URL}/api/editor/save-json`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ experiment_id: experimentId, changes }),
  });
  return parseResponse(res);
};

export const savePageUrl = async (experimentId, pageUrl) => {
  const res = await fetch(`${BACKEND_URL}/api/editor/save-page-url`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ experiment_id: experimentId, pageUrl }),
  });
  return parseResponse(res);
};

export const updateStep = async (experimentId, step) => {
  const res = await fetch(`${BACKEND_URL}/api/editor/update-step`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ experiment_id: experimentId, step }),
  });
  return parseResponse(res);
};

export const saveGoalSelector = async (experimentId, goalSelector) => {
  const res = await fetch(`${BACKEND_URL}/api/editor/save-goal-selector`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ experiment_id: experimentId, goalSelector }),
  });
  return parseResponse(res);
};
